import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { Router } from "@angular/router";
import { Title } from '@angular/platform-browser';
import * as globalVariables from "../../commonVariableList/addInvoice";

@Component({
  selector: 'app-all-module-view',
  templateUrl: './all-module-view.component.html',
  styleUrls: ['./all-module-view.component.scss']
})
export class AllModuleViewComponent implements OnInit {
  @Input() modalDetails: any;
  // @Input() tableDetails: any;
  // @Input() approvalDetails: any;
  // @Input() divDetails: any;
  // @Input() attachment: any;

  @Output()
  sendAction = new EventEmitter()
  commonVariableList: any = {
    "actionsList": [{
      "name": "View",
      "icon": "fa fa-eye",
      "action": "view"
    }],
    "dataList": [],
    "columnList": [],
    "afterdivList": [],
    "beforedivList": [],
    "isProgressing": false,
    "modalDetails":{},
    "isPrView":false,
    "isPoView":false,
    "isIrnView":false,
    "isGrnView":false,
    "isInvoiceView":false,
    "RIT_isInvoiceView":false,
    "name":'',
  };

  constructor(public webService: WebServiceService,
    private toasterService: ToasterService,
    public _localStorageService: LocalStorageService,
    private router: Router, private titleService: Title, ) {
      this.initListener();
  }
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  ngOnInit() {
    if (this.modalDetails.id) {
      this.apiCall();
    }
    // document.getElementById('body').style.overflow = 'hidden';
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
   this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
  }

  getId(id: any, action: string, data: any) {
    this.sendAction.emit({
      "id": id,
      "action": action,
      "data": data,
    });
  }
  hideModal() {
    this.modalDetails.is_all = false;
    localStorage.setItem('dataList', '');
    // document.getElementById('body').style.overflow = 'auto';
  }
  apiCall() {
    this.commonVariableList.is_history=this.modalDetails.is_history?this.modalDetails.is_history:false;
    switch (this.modalDetails.id) {
      case 'poreport':
        this.showAllPOData(this.modalDetails.data);
        break;
        case 'bulkporeport':
          this.modalDetails.id='poreport';
          this.showBulkPOData(this.modalDetails.data);
          break;
        default:
          this.toasterService.pop('error', "Error", "Wrong Data");
      }
    }
  showAllPOData(data) {
    this.commonVariableList.dataList = [];
    let response: any = {};
    let payload: any = { "po_id": data.id?data.id:'' }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('/Po/get_full_po_details', payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response ? data.response : {};
            data.response.invoice= data.response.invoice? data.response.invoice:{"id":''}
            data.response.grn= data.response.grn? data.response.grn:{"id":''}
            data.response.irn= data.response.irn? data.response.irn:{"id":''}
            data.response.po= data.response.po? data.response.po:{"id":''}
            data.response.pr= data.response.pr? data.response.pr:[]

            if(data.response.invoice.id!=undefined && data.response.invoice.id!='')
            {
              this.showInvoice(data.response.invoice);
            }
            if(data.response.grn.id!=undefined && data.response.grn.id!='')
            {
              this.showGrn(data.response.grn);
            }
            if(data.response.irn.id!=undefined && data.response.irn.id!='')
            {
              this.showIrn(data.response.irn);
            }
            if(data.response.po.id!=undefined && data.response.po.id!='')
            {
              data.response.po.po_items=data.response.po.items?data.response.po.items:[];
              this.showPo(data.response.po);
            }
            if(data.response.pr)
            {
              this.showPr(data.response.pr);
            }
            if(data.response.ir)
            {
              this.showIr(data.response.ir);
            }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
          }
          this.commonVariableList.isProgressing = false;

        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showBulkPOData(data) {
    this.commonVariableList.dataList = [];
    let response: any = {};
    let payload: any =[];
    payload=data.payload?data.payload:[]
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('/Po/get_bulk_po_details', payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response ? data.response :[];
            if(data.response)
            {

            for(let i of data.response)
            {
            i.invoice= i.invoice? i.invoice:{"id":''}
            i.grn= i.grn? i.grn:{"id":''}
            i.irn= i.irn? i.irn:{"id":''}
            i.po= i.po? i.po:{"id":''}
            i.pr= i.pr? i.pr:[]

            if(i.invoice.id!=undefined && i.invoice.id!='')
            {
              this.showInvoice(i.invoice);
            }
            if(i.grn.id!=undefined && i.grn.id!='')
            {
              this.showGrn(i.grn);
            }
            if(i.irn.id!=undefined && i.irn.id!='')
            {
              this.showIrn(i.irn);
            }
            if(i.po.id!=undefined && i.po.id!='')
            {
              i.po.po_items=i.po.items?i.po.items:[];
              this.showPo(i.po);
            }
            if(i.pr)
            {
              this.showPr(i.pr);
            }
            if(i.ir)
            {
              this.showIr(i.ir);
            }
          }
        }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
          }
          this.commonVariableList.isProgressing = false;

        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  initListener()
  {
    document.body.addEventListener('keypress', (event) => this.reset(event));
    document.body.addEventListener('keydown', (event) => this.reset(event));
    document.body.addEventListener('keyup', (event) => this.reset(event));

  }
  reset(event)
  {
    if(event.keyCode=='27')
    {
    // this.modalDetails.is_view=false;
    // this.modalDetails.is_all=false;

    // document.body.style.overflow='auto';
    }
  }
  RIT_invoicesReportData: any;
  RIT_isInvoiceView: boolean = false;
  RIT_invoice_tableDetails: any = { "data": {}, "id": "recurring_invoicereport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  RIT_invoice_approvalDetails: any = { "data": {}, "id": "recurring_invoicereport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  RIT_invoice_divDetails: any = { "data": {}, "id": "recurring_invoicereport", "name": 'Po div Details', "Desscription": 'Po divs ', "is_view": true }
  RIT_invoice_attachment:any=[];
  showRecurringInvoice(data) {
   console.log(data);

   data.bill_location_nickname_9_digit=data.bill_location_nickname_9_digit?data.bill_location_nickname_9_digit:''
   data.bill_location_code_9_digit=data.bill_location_code_9_digit?data.bill_location_code_9_digit:'';
   data.ship_location_nickname_9_digit=data.ship_location_nickname_9_digit?data.ship_location_nickname_9_digit:''
   data.ship_location_code_9_digit=data.ship_location_code_9_digit?data.ship_location_code_9_digit:'';
   data.info_History=data.info_History?data.info_History:[]
   data.is_need_info=data.is_need_info?data.is_need_info:false;
   data.company_bank_name = data.bank_name ? data.bank_name : '';
   data.common_ship_location=data.ship_location_nickname_9_digit
   if(data.ship_location_code_9_digit!=''&&data.ship_location_code_9_digit!=undefined&&data.ship_location_code_9_digit!=null)
   {
     data.common_ship_location=data.common_ship_location + " (" + data.ship_location_code_9_digit + ")";

   }
   data.company_bank_accountno = data.bank_accountno ? data.bank_accountno : '';
   if(data.invoice_items)
   {
     for(let i of data.invoice_items)
     {
       i.location=data.ship_location_nickname_9_digit+" ("+data.ship_location_code_9_digit+")";
       i.tds_section_name = i.tds_section_name ? i.tds_section_name : '';
       i.tds_rate = i.tds_rate ? i.tds_rate : i.vendor_tds_rate;
       i.account_name = `${i.account_name} (${i.account_code})`
       i.tds_rate = parseFloat(i.tds_rate);
     }
   }
   data.advance_amount=data.advance_amount?data.advance_amount:'';

    this.RIT_invoicesReportData = {};
    this.RIT_invoicesReportData = data;
    this.RIT_invoicesReportData.irn_cs_id=data.irn_cs_id;
    this.RIT_invoicesReportData.grn_cs_id=data.grn_cs_id;
    this.RIT_invoicesReportData.invoice_cs_id=data.invoice_cs_id;
    this.RIT_invoicesReportData.invoice_payment_cs_id=data.invoice_payment_cs_id;


    this.RIT_invoice_divDetails.data={}
    this.RIT_invoice_divDetails.data=data;
    this.RIT_invoice_approvalDetails.data={}
    this.RIT_invoice_approvalDetails.data=data;
    // this.RIT_invoice_approvalDetails.data.approvals=data.approvals?data.approvals:[];


    this.RIT_invoice_tableDetails.data={}
    this.RIT_invoice_tableDetails.data=data;
    this.RIT_invoice_attachment=[];
    this.RIT_invoicesReportData.attachment = [];
    let attachment: any = [];
    attachment = data.attachments ? data.attachments : []
    if (attachment)
    {
      for (let d of attachment) {
        this.RIT_invoicesReportData.attachment.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachments_url,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }
      this.RIT_invoice_attachment=this.RIT_invoicesReportData.attachment?this.RIT_invoicesReportData.attachment:[];
      this.commonVariableList.RIT_isInvoiceView = true;


  }
  invoicesReportData: any;
  isInvoiceView: boolean = false;
  invoice_tableDetails: any = { "data": {}, "id": "invoicereport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  invoice_approvalDetails: any = { "data": {}, "id": "invoicereport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  invoice_divDetails: any = { "data": {}, "id": "invoicereport", "name": 'Po div Details', "Desscription": 'Po divs ', "is_view": true }
  invoice_attachment:any=[];
  showInvoice(data) {
   console.log(data);

   data.bill_location_nickname_9_digit=data.bill_location_nickname_9_digit?data.bill_location_nickname_9_digit:''
   data.bill_location_code_9_digit=data.bill_location_code_9_digit?data.bill_location_code_9_digit:'';
   data.ship_location_nickname_9_digit=data.ship_location_nickname_9_digit?data.ship_location_nickname_9_digit:''
   data.ship_location_code_9_digit=data.ship_location_code_9_digit?data.ship_location_code_9_digit:'';
   data.info_History=data.info_History?data.info_History:[]
   data.is_need_info=data.is_need_info?data.is_need_info:false;
   data.company_bank_name = data.bank_name ? data.bank_name : '';
   data.common_ship_location=data.ship_location_nickname_9_digit
   if(data.ship_location_code_9_digit!=''&&data.ship_location_code_9_digit!=undefined&&data.ship_location_code_9_digit!=null)
   {
     data.common_ship_location=data.common_ship_location + " (" + data.ship_location_code_9_digit + ")";

   }
   data.company_bank_accountno = data.bank_accountno ? data.bank_accountno : '';
   if(data.invoice_items)
   {
     for(let i of data.invoice_items)
     {
       i.location=data.ship_location_nickname_9_digit+" ("+data.ship_location_code_9_digit+")";
       i.tds_section_name = i.tds_section_name ? i.tds_section_name : '';
       i.tds_rate = i.tds_rate ? i.tds_rate : i.vendor_tds_rate;
       i.account_name = `${i.account_name} (${i.account_code})`
       i.tds_rate = parseFloat(i.tds_rate);
     }
   }
   data.advance_amount=data.advance_amount?data.advance_amount:'';

    this.invoicesReportData = {};
    this.invoicesReportData = data;
    this.invoicesReportData.irn_cs_id=data.irn_cs_id;
    this.invoicesReportData.grn_cs_id=data.grn_cs_id;
    this.invoicesReportData.invoice_cs_id=data.invoice_cs_id;
    this.invoicesReportData.invoice_payment_cs_id=data.invoice_payment_cs_id;


    this.invoice_divDetails.data={}
    this.invoice_divDetails.data=data;
    this.invoice_approvalDetails.data={}
    this.invoice_approvalDetails.data=data;
    // this.invoice_approvalDetails.data.approvals=data.approvals?data.approvals:[];


    this.invoice_tableDetails.data={}
    this.invoice_tableDetails.data=data;
    this.invoice_attachment=[];
    this.invoicesReportData.attachment = [];
    let attachment: any = [];
    attachment = data.attachments ? data.attachments : []
    if (attachment)
    {
      for (let d of attachment) {
        this.invoicesReportData.attachment.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachments_url,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }
      this.invoice_attachment=this.invoicesReportData.attachment?this.invoicesReportData.attachment:[];
      this.commonVariableList.isInvoiceView = true;


  }
  grnsReportData: any;
  isGrnView: boolean = false;
  grn_tableDetails: any = { "data": {}, "id": "grnreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  grn_approvalDetails: any = { "data": {}, "id": "grnreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  grn_divDetails: any = { "data": {}, "id": "grnreport", "name": 'Po div Details', "Desscription": 'Po divs ', "is_view": true }
  grn_attachement:any=[];
  showGrn(data) {


    this.commonVariableList.isGrnView = true;
    data.employee_code=data.added_by_employee_code?data.added_by_employee_code:''
    data.bill_location_nickname_9_digit = data.bill_name?data.bill_name:''
    data.bill_location_code_9_digit =data.bill_location_code_9_digit?data.bill_location_code_9_digit:''
    data.ship_location_nickname_9_digit=data.ship_name?data.ship_name:''
    data.ship_location_code_9_digit=data.ship_location_code_9_digit?data.ship_location_code_9_digit:'';
    // data.bill_to_location = data.bill_name + " (" + data.bill_location_code_9_digit + ")";
    // data.ship_to_location = data.ship_name + " (" + data.ship_location_code_9_digit + ")";
    if (data.grn_items) {
      let sl_no: number = 1;

      for (let j of data.grn_items) {
        j.is_closed = j.is_closed == '1' ? true : false;
        j.send_damage_mail = j.send_damage_mail == "1" ? true : false;
        j.sl_no = sl_no;

        sl_no++;
      }
    }
    this.grnsReportData = {};
    this.grnsReportData = data;
    this.grnsReportData.irn_cs_id=data.irn_cs_id;
    this.grnsReportData.grn_cs_id=data.grn_cs_id;
    this.grnsReportData.po_no=data.po_id?data.po_id:'';

    this.grnsReportData.attachment = [];


    this.grn_divDetails.data={}
    this.grn_divDetails.data=data;
    this.grn_approvalDetails.data={}
    this.grn_approvalDetails.data=data;

    this.grn_tableDetails.data={}
    this.grn_tableDetails.data=data;
    this.grn_attachement=[];

    let attachment: any = [];
    attachment = data.grn_attachments ? data.grn_attachments : []
    if (attachment)
    {
      for (let d of attachment) {
        this.grnsReportData.attachment.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachment_name,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }
      this.grn_attachement=attachment?attachment:[];

  }




  irnReportData: any;
  isIrnView: boolean = false;
  irn_tableDetails: any = { "data": {}, "id": "irnreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  irn_approvalDetails: any = { "data": {}, "id": "irnreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  irn_divDetails: any = { "data": {}, "id": "irnreport", "name": 'Po div Details', "Desscription": 'Po divs ', "is_view": true }
  irn_attachement:any=[];
  showIrn(data) {


    this.commonVariableList.isIrnView = true;
    data.approvals=[];
    data.approvals.push({"approval_status":data.approval_status,"employee_code":data.approval_employee_code,
    "approval_first_name":data.approval_first_name,"approval_last_name":data.approval_last_name,
  "date_added":data.date_added,"date_updated":data.date_updated,"approval_by":data.approval_by,'reason':''})
    this.irnReportData = {};
    this.irnReportData = data;
    this.irnReportData.irn_cs_id=data.irn_cs_id;
    this.irnReportData.attachment = [];
    this.irnReportData.date_added=this.webService.formatDate(new Date(data.date_added),'yy-mm-dd','-')
    this.irnReportData.date_updated=this.webService.formatDate(new Date(data.date_updated),'yy-mm-dd','-')

    data.bill_to_location=data.bill_to_location_name?data.bill_to_location_name:'';
    data.ship_to_location=data.ship_to_location_name?data.ship_to_location_name:'';
if(data.irn_items)
{
  for(let d of data.irn_items)
  {
    d.is_damaged = d.is_damaged == "1" ? true : false;

  }
}

    this.irn_divDetails.data={}
    this.irn_divDetails.data=data;
    this.irn_divDetails.data.requested_by_first_name=data.added_by_first_name?data.added_by_first_name:'';
    this.irn_divDetails.data.requested_by_last_name=data.added_by_last_name?data.added_by_last_name:'';
    this.irn_divDetails.data.requested_by_employee_code=data.added_by_employee_code?data.added_by_employee_code:'';

    this.irn_approvalDetails.data={}
    this.irn_approvalDetails.data=data;

    this.irn_tableDetails.data={}
    this.irn_tableDetails.data=data;
    this.irn_attachement=[];

    let attachment: any = [];
    attachment = data.irn_attachments ? data.irn_attachments : []
    if (attachment)
    {
      for (let d of attachment) {
        this.irnReportData.attachment.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachment_name,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }
      this.irn_attachement=attachment?attachment:[];

  }
  poReportData: any;
  isPoView: boolean = false;

  po_tableDetails: any = { "data": {}, "id": "poreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  po_approvalDetails: any = { "data": {}, "id": "poreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  po_divDetails: any = { "data": {}, "id": "poreport", "name": 'Po div Details', "Desscription": 'Po divs ', "is_view": true }
  po_attachement:any=[];
  showPo(data) {


    this.commonVariableList.isPoView = true;
    data.requested_by_employee_code=data.requested_by_employeecode?data.requested_by_employeecode:'';
    data.ship_to_location=data.ship_to_location_name.location?data.ship_to_location_name.location:'';
    data.bill_location_nickname_9_digit=data.bill_to_location_name.location_nickname_9_digit?data.bill_to_location_name.location_nickname_9_digit:''
    data.bill_location_code_9_digit=data.bill_to_location_name.location_code_9_digit?data.bill_to_location_name.location_code_9_digit:'';

    data.is_rented = data.is_rented == "1" ? true : false;
    data.is_different_document_currency = data.is_different_document_currency == "1" ? true : false;
    data.is_boq = data.is_boq == "1" ? true : false;
    data.high_sea_level = data.high_sea_level == "1" ? true : false;

    data.exclude_gst = data.exclude_gst == "1" ? true : false;

    if(data.items)
    {
      for(let i of data.items)
      {
        i.is_logistic = i.is_logistic == '1' ? true : false;
        i.ship_to_location= data.ship_to_location? data.ship_to_location:'';


        i.amend_po_status=i.is_amend=='1'?'Closed':'';
        i.amend_po_qty=i.is_amend=='1'?i.close_po_qty:'';
        i.amend_date=i.amend_date?i.amend_date:'';
        i.amend_added_by=i.amend_added_by?i.amend_added_by:'';
      }
    }
    this.poReportData = {};
    this.poReportData = data;
    this.poReportData.attachment = [];

    this.po_divDetails.data={}
    this.po_divDetails.data=data;
    this.po_approvalDetails.data={}
    this.po_approvalDetails.data=data;

    this.po_tableDetails.data={}
    this.po_tableDetails.data=data;
    this.po_attachement=[];

    let attachment: any = [];
    attachment = data.attachments ? data.attachments : []
    if (attachment)
    {
      for (let d of attachment) {
        this.po_attachement.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachments_url,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }

      // this.po_attachement=attachment?attachment:[];

  }
  prReportData: any;
  pr_tableDetails: any = { "data": {}, "id": "prreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
  pr_approvalDetails: any = { "data": {}, "id": "prreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
  pr_divDetails: any = { "data": {}, "id": "prreport", "name": 'Pr div Details', "Desscription": 'Pr divs ', "is_view": true }
  pr_attachement:any=[];
  isPrView: boolean = false;
  prData:any=[];
  showPr(data) {
    console.log("inside all module",data)
    this.prData=[];
    this.prReportData = {};
    this.pr_attachement=[];
    if(data)
    {
      for(let i of data)
      {
        i.is_boq=i.is_boq=='1'?true:false

        if(i.pr_items)
        {
          for(let j of i.pr_items)
          {
            j.product_name=j.product.product_name?j.product.product_name:''
            j.productcode=j.product.productcode?j.product.productcode:''
            j.product_type=j.product.product_type?j.product.product_type:''
            j.product_catalog_id=j.product.product_catalog_id?j.product.product_catalog_id:''

          }
        }
        i.requested_by = i.user.first_name + " " + i.user.last_name + " (" + i.user.employee_code + ")"
        i.customer_detail='';
        // if(i.customer_first_name!='' &&i.customer_first_name!=undefined)
        // {
        // i.customer_detail=i.customer_first_name+" "+i.customer_last_name+" ("+i.customer_code+")";
        // }
        // if(i.customer_address!='' && i.customer_address!=null)
        // {
         i.customer_detail=i.customer_address?i.customer_address:'';
         i.customer_details=i.customer_address?i.customer_address:'';

        // }
        if(i.approvals)
        {
        for (let x of i.approvals) {
          x.employee_code = x.user.employee_code;
          x.approval_first_name = x.user.first_name;
          x.approval_last_name = x.user.last_name;
        }
      }
        i.location=i.location.location?i.location.location:'';
        i.pr_tableDetails = { "data": {}, "id": "prreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
        i.pr_approvalDetails = { "data": {}, "id": "prreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
        i.pr_divDetails = { "data": {}, "id": "prreport", "name": 'Pr div Details', "Desscription": 'Pr divs ', "is_view": true }
        i.pr_divDetails.data={}
        i.pr_divDetails.data=i;
        i.pr_approvalDetails.data={}
        i.pr_approvalDetails.data=i;

        i.pr_tableDetails.data={}
        i.pr_tableDetails.data=i;
        i.pr_attachement=[];

        let attachment: any = [];
        attachment = i.attachments ? i.attachments : []
        if (attachment)
          for (let d of attachment) {
            this.pr_attachement.push({
              "url": d.attachments_url,
              "name": d.attachment_name,
              "display": d.attachments_url,
              "filename": d.attachment_name,
              "filetype": this.webService.getFileExtension(d.attachment),
              "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
            });
          }
    i.pr_attachement=this.pr_attachement?this.pr_attachement:[];
        this.prData.push(i)
      }
    }
    this.commonVariableList.isPrView = true;


  }

  irReportData: any;
  ir_tableDetails: any = { "data": {}, "id": "irreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
  ir_approvalDetails: any = { "data": {}, "id": "irreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
  ir_divDetails: any = { "data": {}, "id": "irreport", "name": 'Pr div Details', "Desscription": 'Pr divs ', "is_view": true }
  ir_attachement:any=[];
  isIrView: boolean = false;
  irData:any=[];
  showIr(data) {
    console.log("inside all module",data)
    this.irData=[];
    this.irReportData = {};
    this.ir_attachement=[];
    if(data)
    {
      for(let i of data)
      {
        i.is_boq=i.is_boq=='1'?true:false

        if(i.ir_items)
        {
          for(let j of i.ir_items)
          {
            j.product_name=j.product.product_name?j.product.product_name:''
            j.productcode=j.product.productcode?j.product.productcode:''
            j.product_type=j.product.product_type?j.product.product_type:''
            j.product_catalog_id=j.product.product_catalog_id?j.product.product_catalog_id:''

          }
        }
        i.requested_by = i.user.first_name + " " + i.user.last_name + " (" + i.user.employee_code + ")"

        if(i.approvals)
        {
        for (let x of i.approvals) {
          x.employee_code = x.user.employee_code;
          x.approval_first_name = x.user.first_name;
          x.approval_last_name = x.user.last_name;
        }
      }
        i.location=i.location.location?i.location.location:'';
        i.ir_tableDetails = { "data": {}, "id": "irreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
        i.ir_approvalDetails = { "data": {}, "id": "irreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
        i.ir_divDetails = { "data": {}, "id": "irreport", "name": 'Pr div Details', "Desscription": 'Pr divs ', "is_view": true }
        i.ir_divDetails.data={}
        i.ir_divDetails.data=i;
        i.ir_approvalDetails.data={}
        i.ir_approvalDetails.data=i;

        i.ir_tableDetails.data={}
        i.ir_tableDetails.data=i;
        i.ir_attachement=[];

        let attachment: any = [];
        attachment = i.attachments ? i.attachments : []
        if (attachment)
          for (let d of attachment) {
            this.pr_attachement.push({
              "url": d.attachments_url,
              "name": d.attachment_name,
              "display": d.attachment_name,
              "filename": d.attachment_name,
              "filetype": this.webService.getFileExtension(d.attachment),
              "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
            });
          }
    i.ir_attachement=this.ir_attachement?this.ir_attachement:[];
        this.irData.push(i)
      }
    }
    this.commonVariableList.isIrView = true;


  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1882327397/src/src/app/generic-ui-components/all-module-view/all-module-view.component.ts